import { render, staticRenderFns } from "./TestAccessPointDetails.vue?vue&type=template&id=4bde8af4"
import script from "./TestAccessPointDetails.vue?vue&type=script&lang=js"
export * from "./TestAccessPointDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports